import React, { useContext, useEffect, useState } from "react";
import { Button, Card, Col, Row, Spinner } from "react-bootstrap";
import { FaUserCircle } from "react-icons/fa";
import { Link } from "react-router-dom";
import {
  BASE_URL_API_BLOG,
} from "../Utils/Constant";
import { GlobalContext } from "../Context/GlobalState";
import { Authorblogmodal } from "./Modal";
import { apibasicauth } from "../Utils/Credentials";
const Blogauthor = () => {
  const [loading, setLoading] = useState(false);
  const {
    setTransactionLoaderState,
    Productname,
  } = useContext(GlobalContext);
  const { password, username } = apibasicauth;
  const base64Credentials =
    typeof window === "undefined"
      ? Buffer.from(`${username}:${password}`).toString("base64")
      : btoa(`${username}:${password}`);
  const [authors, setAuthors] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [Authormodal, setAuthormodal] = useState(false);
  const GetAuthorsBlog = async () => {
    setLoading(true);
    setTransactionLoaderState(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          slug: "all",
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_BLOG}/GetAuthorsBlog`,
        requestOptions
      );
      const data = await res.json();
      console.log("Geteditloadblog response:", data);

      if (data.status === "0") {
        setAuthors(data?.data);
      } else {
        console.error("Failed to fetch blogs:", data.msg);
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setTransactionLoaderState(false);
      setLoading(false);
    }
  };
  const filteredAuthors = authors?.filter(
    (author) =>
      author.fullname &&
      author.fullname.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    GetAuthorsBlog();
  }, [Productname]);

  return (
    <>
      <div className="row mt-3">
        <div className="col">
          <h4 className="">Authors</h4>
        </div>
        <div className="col d-flex justify-content-end">
          <div className="mr-2">
            <input
              className="p-2"
              type="text"
              placeholder="Search authors..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                width: "100%",
                borderRadius: ".4rem",
                border: "1px solid #ccc",
                height: "2.2rem",
              }}
            />
          </div>
          <Button
            style={{ height: "2rem" }}
            variant="success"
            size="sm"
            onClick={() => setAuthormodal(true)}
          >
            Add Author
          </Button>
        </div>
      </div>
      {loading ? (
        <div className="d-flex justify-content-center align-items-center my-5 w-100">
          <Spinner animation="border" variant="success" />
        </div>
      ) : (
        <Row className="g-4">
          {filteredAuthors.map((author) => (
            <Col key={author.id} md={2} sm={4}>
              <Link
                to={`/author/${author.slug}`} 
                style={{ textDecoration: "none" }}
              >
                <Card className="p-2">
                  <div
                    style={{
                      width: "100%",
                      height: "200px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#f0f0f0",
                    }}
                  >
                    {author.profile_image ? (
                      <Card.Img
                        variant="top"
                        src={author.profile_image}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      <div
                        style={{
                          width: "100%",
                          height: "100%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          color: "#888",
                        }}
                      >
                        <FaUserCircle size={100} />
                      </div>
                    )}
                  </div>
                  <p
                    className="m-1 d-flex justify-content-center"
                    style={{ color: "#000" }}
                  >
                    <b>{author.fullname}</b>
                  </p>
                </Card>
              </Link>
            </Col>
          ))}
        </Row>
      )}

      <Authorblogmodal
        Authormodal={Authormodal}
        setAuthormodal={setAuthormodal}
        GetAuthorsBlog={GetAuthorsBlog}
      />
    </>
  );
};

export default Blogauthor;
